import _ from 'lodash';

export default {
    toString: function toString(code) {
        if (!code || ['code', 'classification'].some(function (prop) {
            return !code[prop];
        })) {
            return '';
        }

        // Handles both raw value and viewmodel.
        return _.get(code, 'code.value', code.code) + ': ' + _.get(code, 'classification.value', code.classification);
    }
};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/util/PropertyCodeUtil.js
// module id = 59
// module chunks = 0